import Vue from "vue";
import Vuex from "vuex";

import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // 全画面モードかどうかを管理するフラグ
    full_screen_flg: false,
    // 検索ワード
    search_words: [],
    // twitterアカウント
    twitter_account: {
      is_login: false,
      avatar_img_src: "",
      user_name: "",
      twitter_screen_name: ""
    },
    login: {
      auth_token: "",
      user_id: ""
    },
    login_callback_route_name: "home",
    login_callback_route_query: null,
    tags: [],
    drawType: "new",
    //ユーザーによる検索結果
    search_result: []
  },
  getters: {
    getSearchWords: state => {
      return state.search_words;
    },
    getSearchResult: state => {
      return state.search_result;
    }
  },
  mutations: {
    setFullScreenFlg(state, full_screen_flg) {
      state.full_screen_flg = full_screen_flg;
    },
    /**
     * 検索ワードを追加する.
     * 重複してた場合は追加しない.
     */
    addSearchWord(state, word) {
      const duplicateWord = state.search_words.find(w => w === word);
      if (!duplicateWord) {
        state.search_words.push(word);
      }
    },
    /**
     * 検索ワードリストを新しくする
     */
    setSearchWords(state, searchWords) {
      state.search_words.length = 0;
      for (let word of searchWords) {
        state.search_words.push(word);
      }
    },
    /**
     * ツイッターアカウントをリセットする
     * @param {*} state
     */
    resetTwitterAccount(state) {
      state.twitter_account.is_login = false;
      state.twitter_account.avatar_img_src = "";
      state.twitter_account.user_name = "";
      state.twitter_account.twitter_screen_name = "";
    },
    /**
     * ツイッターアカウントを設定する
     * @param {*} state
     * @param {*} userName アカウント名
     * @param {*} userImageUrl アカウントアイコンURL
     */
    setTwitterAccount(state, { userName, userImageUrl, twitterScreenName}) {
      state.twitter_account.is_login = true;
      state.twitter_account.avatar_img_src = userImageUrl;
      state.twitter_account.user_name = userName;
      state.twitter_account.twitter_screen_name = twitterScreenName;
    },
    /**
     * ツイッターログインした際のトークンやユーザIDを設定する.
     *
     * @param {*} state
     * @param {*} param1
     */
    login(state, { token, user_id }) {
      state.login.auth_token = token;
      state.login.user_id = user_id;
    },
    /**
     * トークンやユーザIDをデフォルトに戻す.
     * @param {*} state
     */
    logout(state) {
      state.login.auth_token = "";
      state.login.user_id = "";
    },
    /**
     * ツイッターログインからのリダイレクト先を指定する.
     * 何も指定しなければhomeにリダイレクトする.
     * @param {*} state
     * @param {*} routeName
     */
    setLoginCallbackRouteName(state, routeName = "home") {
      state.login_callback_route_name = routeName;
    },
    setLoginCallbackQuery(state, routeQuery = null) {
      state.login_callback_route_query = routeQuery;
    },
    setGraphTag(state, tags) {
      state.tags.length = 0;
      for (let tag of tags) {
        state.tags.push(tag);
      }
      state.tags.push("emoooo");
    },
    setGraphType(state, drawType) {
      state.drawType = drawType;
    },
    setSearchResult(state, payload) {
      state.search_result = payload;
    }
  },
  plugins: [createPersistedState()]
});
